'use client'
import classNames from 'classnames'
import type { FC } from 'react'
import { AddressAnimation } from '../address-animation/AddressAnimation'
import { AddressInputContainer } from '../address-input-container/AddressInputContainer'
import styles from './HeroContainer.module.scss'
import { HeroWave } from './HeroWave'
import { useLocalisation } from '@/tools/i18n/client'

export const HeroContainer: FC = () => {
  // eslint-disable-next-line react-hooks/rules-of-hooks
  const { t } = useLocalisation()

  return (
    <section className={styles['hero-container']}>
      <div className={styles['hero-container__content']}>
        <AddressAnimation />
        <div className={styles['hero-container__content__text']}>
          <h1
            className={classNames(
              'pintxo-typography-feature2',
              styles['hero-container__content__text__title']
            )}
          >
            {t('landing.address-container-title')}
          </h1>
          <p
            className={classNames(
              'pintxo-typography-title3',
              styles['hero-container__content__text__subtitle']
            )}
          >
            {t('landing.address-container-subtitle')}
          </p>
          <AddressInputContainer />
        </div>
      </div>
      <HeroWave />
    </section>
  )
}
